/** Claims — create view (delegates to the shared ClaimForm). */
import { ClaimForm } from "./_ClaimForm";

export function ClaimCreate() {
  return <ClaimForm action="create" />;
}

export default ClaimCreate;
